import { Box, Typography } from "@mui/material";
import React from "react";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import Logo from "../assets/logo.png";

const RatingsData = [
  {
    rating: 5,
    ratingDesc: "Ease of Use",
    date: "March 14, 2024",
    description:
      "Helpsoo has made managing school activities so much easier. Highly recommend!",
    user: "Sarah Williams",
  },
  {
    rating: 4,
    ratingDesc: "Customer Support",
    date: "February 26, 2024",
    description: "The support team is always ready to help and very friendly.",
    user: "Michael Brown",
  },
  {
    rating: 5,
    ratingDesc: "Functionality",
    date: "February 08, 2024",
    description:
      "Helpsoo's features are exactly what we needed to streamline our school's management.",
    user: "Emily Davis",
  },
];

const Ratings = () => {
  return (
    <Box textAlign={"left"} mx={"20%"} my={10}>
      <Typography sx={{ fontWeight: 600, fontSize: 30 }}>
        What People Are Saying
      </Typography>
      <Typography sx={{ fontSize: 15, color: "#6b7c91" }}>3 reviews</Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          pt: 4,
        }}
      >
        {RatingsData.map((item) => {
          return (
            <Box
              sx={{ border: "1px solid #6b7c91", borderRadius: 2, p: 3, m: 1 }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex" }}>
                  {Array(5)
                    .fill(0)
                    .map((_, index) => {
                      return index + 1 <= item.rating ? (
                        <StarIcon sx={{ color: "#347AEA" }} />
                      ) : (
                        <StarBorderIcon sx={{ color: "#347AEA" }} />
                      );
                    })}
                  <Typography sx={{ px: 1 }}>for</Typography>
                  <Typography sx={{ fontWeight: 900 }}>
                    {item.ratingDesc}
                  </Typography>
                </Box>
                <Typography sx={{ color: "#6b7c91", alignSelf: "flex-end" }}>
                  {item.date}
                </Typography>
              </Box>
              <Typography py={1}>{item.description}</Typography>
              <Box sx={{ display: "flex", pt: 3 }}>
                <Box
                  component={"img"}
                  src={Logo}
                  sx={{ width: 30, height: 30 }}
                />
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#0f172a",
                    px: 2,
                    alignSelf: "center",
                  }}
                >
                  {item.user}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Ratings;
